import {loadTicketClaimRef} from '../reference/actions'
import {loadTicket} from '../ticket/actions'
import {loadPatrimony, loadContact as loadPatrimonyContact} from '../patrimony/actions'
import {DEFAULT_TICKET_CLAIM_QUERY, loadTicketClaimStream, loadTicketClaim, createTicketClaim} from './actions'
import TicketClaimLayout from './components/TicketClaimLayout'
import TicketClaimStreamLayout from './components/TicketClaimStreamLayout'
import TicketClaimDetail from './components/TicketClaimDetail'

export default function(rootPath, dispatcher, {getState}) {

    function enterTicketClaimStream(dispatch) {
        const state = getState()
        const {criteria} = state.claim

        return dispatch(loadTicketClaimStream({...DEFAULT_TICKET_CLAIM_QUERY, ...criteria}))
    }

    function enterNewTicketClaim(dispatch) {
        const state = getState()
        const {openTicketClaimCmd} = state.claim
        
        const ticketReference = {
            uid: openTicketClaimCmd && openTicketClaimCmd.ticketUid,
            referenceType: (openTicketClaimCmd && openTicketClaimCmd.commandType == 'OpenTicketClaim') && 'ReferencedTicket' || 'ExternalTicket'
        }

        return Promise.all([
            dispatch(createTicketClaim({ticketReference})),
            dispatch(loadTicketClaimRef())
        ]).then(([createTicketClaimAction]) => {
            const ticketId = createTicketClaimAction.ticketClaim.ticketReference.uid
            return ticketId && dispatch(loadTicket(ticketId))
        }).then((loadTicketAction) => {
            const patrimony = loadTicketAction && loadTicketAction.ticket.linkedEntities.patrimony
            return Promise.all([
                patrimony && dispatch(loadPatrimony(patrimony.uid)),
            ])
        })
    }

    function enterTicketClaim(dispatch, params) {
        return Promise.all([
            dispatch(loadTicketClaim(params.id)),
            dispatch(loadTicketClaimRef())
        ]).then(([loadTicketClaimAction]) => {
            const ticketId = loadTicketClaimAction.ticketClaim.ticketReference.uid
            return ticketId && dispatch(loadTicket(ticketId))
        }).then((loadTicketAction) => {
            const patrimony = loadTicketAction && loadTicketAction.ticket.linkedEntities.patrimony
            const caller = loadTicketAction && loadTicketAction.ticket.caller
            return Promise.all([
                patrimony && dispatch(loadPatrimony(patrimony.uid)),
                caller && caller.callerInfos.callerType === 'PatrimonyContactCaller' && dispatch(loadPatrimonyContact(caller.uid))
            ])
        })
    }

    return {
        path: rootPath,
        component: TicketClaimLayout,
        onEnter: dispatcher(enterTicketClaimStream),
        indexRoute: {
            component: TicketClaimStreamLayout
        },
        childRoutes: [{
            path: 'new',
            component: TicketClaimDetail,
            onEnter: dispatcher(enterNewTicketClaim)
        }, {
            path: ':id',
            component: TicketClaimDetail,
            onEnter: dispatcher(enterTicketClaim)
        }]
    }
}


// WEBPACK FOOTER //
// ./lib/claim/routes.js